<template>
  <div class="main-wrapper-container publication-page">
    <academy-block/>
  </div>
</template>

<script>
import AcademyBlock from "@/components/entities/block/AcademyBlock.vue";

export default {
  name: "CreateAcademyPage",
  components: {AcademyBlock},

}
</script>

<style scoped>

</style>
